import { Component, Prop, h, Host, Listen, Event, EventEmitter, Element } from '@stencil/core';
import { translations } from './translations';
import { Menui18n } from './types';
import state from './pn-mainnav-store';
import { close, bars } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-mainnav',
  styleUrl: 'pn-mainnav.scss',
  shadow: false,
})
export class PnMainnav {
  @Element() hostElement: HTMLElement;
  /** Specifies which market we want to fetch navigation for (se,dk,fi,no,com) */
  @Prop() market: string = 'se';
  /** Specifies which language we want to show navigation in (sv,da,fi,no,en) */
  @Prop() language: string = 'sv';
  /** Specifies which endpoint we should read information from */
  @Prop() navigationId: string = 'mainnav';
  /** Specifies which endpoint we should read information from */
  @Prop({ mutable: true }) openMenu: boolean = false;
  /** Sets the label of the navigation (Required if multiple nav elements are on a page) */
  @Prop() navLabel: string = '';

  @Event() menuLanguageChange: EventEmitter; // Could not use language change since it's a existing window event
  @Event() marketChange: EventEmitter;
  @Event() menuOpenChange: EventEmitter;

  componentWillLoad() {
    this.init();
    document.removeEventListener('mousedown', this._onClickOutside.bind(this));
    document.addEventListener('mousedown', this._onClickOutside.bind(this));
  }

  async init() {
    this.setLanguage();
    this.setMarket();
  }

  private _onClickOutside(event) {
    const clickedOutside = !this.hostElement.contains(event.target);
    if (clickedOutside) {
      state.openLevel = '';
    }
  }

  @Listen('language')
  setLanguage() {
    this.menuLanguageChange.emit(this.language);
  }

  @Listen('market')
  setMarket() {
    this.marketChange.emit(this.market);
  }

  @Listen('menuLanguageChange')
  onLanguageChange(event) {
    if (translations[event.detail]) {
      state.i18n = translations[event.detail] as Menui18n;
      if (!this.navLabel) {
        this.navLabel = state.i18n.navLabel;
      }
    }
  }

  @Listen('setmenuopenstate')
  setMenuOpenState() {
    state.openMenu = !state.openMenu;
    this.menuOpenChange.emit(state.openMenu);
  }

  @Listen('openMenuLevelChange')
  onOpenMenuLevelChange(event) {
    state.openLevel = event.detail;
  }

  render() {
    return (
      <Host>
        <div class="mainnav-toggle">
          <button aria-controls={this.navigationId} aria-expanded={state.openMenu + ''} onClick={this.setMenuOpenState.bind(this)}>
            {state.i18n.mainMenuButton}
            <pn-icon icon={state.openMenu ? close : bars} color="white"></pn-icon>
          </button>
        </div>
        <nav class="mainnav" aria-label={this.navLabel} data-menu-open={state.openMenu + ''} data-menu-currentlevel={state.currentLevel} id={this.navigationId}>
          <slot></slot>
        </nav>
      </Host>
    );
  }
}
